// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"464":"c663d9054c359595","896":"db256df56d49047f"}[chunkId] + ".js";
};